import styled from "styled-components";

export const Img = styled.img``;
